module.exports = __webpack_public_path__ + "Tenant.52e09750c139d4cdeda4ce8dfffdf13a.hashedasset.svg";